<template>
  <div>
    <div class="shadow rounded md:w-3/4 sm:w-full bg-white p-6 flex items-start space-x-4">
      <div>
        <img :src="require(`@/assets/${product.metadata.image_name}`)"
             :alt="productName" class="w-80" width='80px' />
      </div>
      <div class="flex flex-col w-full">
        <h3 class="leading-6 text-xl font-bold text-gray-800">
          {{ product.name }}
        </h3>
        <div class="mt-1 text-sm text-gray-500 leading-4">
          <section v-if="(product.metadata.is_parent && product.metadata.is_parent === 'true')" >
            <div class="md:flex sm:columns-1 md:columns-2 md:gap-10">
                <div class="text-gray-700 flex-initial md:w-3/4 sm:w-full
                 leading-5 md:text-justify">
                  {{ product.metadata.description }}
                </div>
                <div class="flex flex-col md:w-1/6 sm:w-full mt-2 md:mt-0">
                  <a
                    class="sm:w-full md:w-32 md:ml-4 text-center
                    content-center bg-gray-600 hover:bg-gray-800
                    rounded py-2 px-6 text-white text-sm"
                    :href="product.metadata.learn_more_link"
                    target="_blank"
                    rel="noopener noferrer" v-show="product.metadata.learn_more_link
          && product.metadata.learn_more_link !== ''">
                    Learn More
                  </a>
                  <section v-if="isAccountOwner && !hasChildren && isLive">
                    <m-button class='w-full md:w-32 md:ml-4 mt-2'
                      @click="handlePurchase"
                    >
                      Purchase
                    </m-button>
                    <m-modal
                      :show="show"
                      @close="handleClose"
                      :sidebarHeaderText="modalHeaderText"
                      :isSidebar="true"
                    >
                      <purchase :product="product"></purchase>
                    </m-modal>
                  </section>
                  <m-button class="w-full md:w-32 md:ml-4 mt-2" v-show="!hasChildren
                   && hasAccessToApp" @click="bites"
                  >Let's Go</m-button
                  >
                  <m-button
                    v-if="!isAccountOwner && !hasChildren && isLive && !hasAccessToApp"
                    class="w-full md:w-32 md:ml-4 mt-2"
                    @click="showRequest = true">
                    Request Access
                  </m-button>
                  <section v-if="
                    (product.metadata.register_interest_link &&
                    product.metadata.register_interest_link !== '') &&
                    (product.metadata.live && product.metadata.live === 'false')
                    ">
                    <a
                      class="w-full md:w-32 md:ml-4 mt-2 btn btn-primary text-center"
                      :href="product.metadata.register_interest_link"
                      target="_blank"
                      rel="noopener noferrer">
                      Register Interest
                    </a>
                  </section>
                </div>
            </div>
          </section>
          <section v-if="product.metadata.has_children && product.metadata.has_children === 'true'">
            <learning-product-child
              v-for="product in childProducts"
              :key="product.id"
              :product="product" class='mt-5'
            ></learning-product-child>
          </section>
        </div>
      </div>
      <m-modal :show="showRequest" @close="showRequest = false">
        <request-access @close="showRequest = false" />
      </m-modal>
    </div>
  </div>
</template>

<script>
import Purchase from './purchase.vue';
import LearningProductChild from '@/app/modules/account/components/purchase/learning-product-child.vue';
import RequestAccess from '@/app/modules/home/components/request-access/request-access.vue';

const absorbURL = process.env.VUE_APP_ABSORB_URL;
export default {
  name: 'parent-product',
  components: {
    RequestAccess,
    Purchase,
    LearningProductChild,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      showRequest: false,
    };
  },
  computed: {
    hasAccessToApp() {
      const appName = this.product.app;
      return this.$store.getters['account/getAccountCanAccess'][appName];
    },
    isAccountOwner() {
      return this.$store.getters['account/isAccountOwner'];
    },
    hasChildren() {
      return this.product.metadata.has_children && this.product.metadata.has_children === 'true';
    },
    isLive() {
      return this.product.metadata.live && this.product.metadata.live === 'true';
    },
    modalHeaderText() {
      return `Purchase - ${this.product.name}`;
    },
    productName() {
      return this.product.name;
    },
    childProducts() {
      const products = this.$store.getters['billing/getPurchases'];
      const childProducts = products.filter(product => product.metadata && product.metadata.is_child === 'true' && product.app.startsWith(this.product.metadata.children_prefix));
      return childProducts.sort((a, b) => a.metadata.order - b.metadata.order);
    },
  },
  methods: {
    handlePurchase() {
      this.show = true;
    },
    handleClose() {
      this.show = false;
    },
    bites() {
      this.$mixpanel.track('bites-init', {
        location: 'Dashboard',
      });
      window.open(absorbURL, '_blank', 'noopener noreferrer');
    },
  },
};
</script>
